module.exports = __webpack_public_path__ + "img/arrow_survey_next.64778b80.svg";